import React, { useRef } from 'react';
import styled from 'styled-components';
import 'react-html5video/dist/styles.css';
import { DefaultPlayer as VideoPlayer } from 'react-html5video';
import Modal from 'react-modal';
import CloseButton from './CloseButton';

const modalStyles = {
  overlay: {
    zIndex: 10005,
    background: '#000000',
  },
  content: {
    padding: '50px 0 0 0',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#000000',
    zIndex: 10005,
    border: 'none',
  },
};

Modal.setAppElement('#___gatsby');

const StyledCloseButton = styled(CloseButton)`
  top: 0;
  position: fixed;
  right: 20px;

  @media (max-height: 768px) and (min-width: 768px) {
    top: 70px;
  }
`;

function Video({
  video, poster, isOpen, closeModal,
}) {
  const videoEl = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Video"
      style={modalStyles}
    >
      {' '}
      <VideoPlayer
        ref={videoEl}
        autoPlay={isOpen}
        controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
        poster={poster}
      >
        <source
          src={video}
          type="video/mp4"
        />
      </VideoPlayer>
      <StyledCloseButton onClick={closeModal} />
    </Modal>
  );
}

export default Video;
